import React from 'react'
import { unmountComponentAtNode, render } from 'react-dom'
import Button, { ButtonProps } from '../Button'
// @ts-ignore
import s from './index.module.sass'
export interface ModalProps {
  title: string
  content: string
  confirmText?: string
  confirm: (yes: boolean) => void
  modifier?: ButtonProps['modifier']
}

export default function Modal(props: ModalProps) {
  return <div className={s['modal-fixed']}>
    <div className={s['modal-body']}>
      <div className={s['modal-main']}>
        <div className={s['modal-title']}>
          {props.title}
        </div>
        <div className={s['modal-bottom']}>
          <div className={s['modal-text']}>
            {props.content}
          </div>
          <div className={s['modal-buttons']}>
            <div className={s['mb-12']}>
              <Button modifier={props.modifier ? props.modifier : 'postive'} text={props.confirmText || '确定'} onClick={() => {
                props.confirm(true)
              }} size="c48"></Button>
            </div>
            <div>
              <Button modifier="blue" text="我再想想" style={{ padding: '0 35px' }} onClick={() => {
                props.confirm(false)
              }} size="c48"></Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

let modalContainer: HTMLDivElement | undefined

let unMountModal: undefined | ((yes?: boolean) => void)


function getModalContainer() {
  if (modalContainer == null) {
    modalContainer = document.createElement('div')
    modalContainer.setAttribute('data-modal-container', '')
    document.body.appendChild(modalContainer)
  }
  return modalContainer as HTMLDivElement
}

export function showModal(title: string, content: string, confirmText?: string, modifier?: ButtonProps['modifier']): Promise<boolean> {
  if (unMountModal != null) {
    unMountModal()
  }
  let resolve: any
  let reject: any

  render(<Modal title={title} content={content} confirmText={confirmText} modifier={modifier} confirm={(yes) => {
    if (unMountModal) {
      unMountModal(yes)
    }
  }} />, getModalContainer())
  unMountModal = (yes) => {
    unMountModal = undefined
    unmountComponentAtNode(getModalContainer())
    if (yes === undefined) {
      reject()
      return
    }
    resolve(yes)
  }
  return new Promise((_resolve, _reject) => {
    resolve = _resolve
    reject = _reject
  })
}
